export const menuItems = [
  {
    group: 'reporting',
    label: 'sidebar.Usage',
    to: '/usage',
    icon: 'data_usage',
  },
  {
    group: 'reporting',
    label: 'sidebar.UsageTraffic',
    to: '/usage-traffic',
    icon: 'bar_chart',
  },
  {
    group: 'reporting',
    label: 'sidebar.Thresholds',
    to: '/thresholds',
    icon: 'data_thresholding',
  },
  {
    group: 'management',
    label: 'sidebar.Environments',
    to: '/environments',
    icon: 'domain',
  },
  {
    group: 'management',
    label: 'sidebar.Accounts',
    to: '/accounts',
    icon: 'manage_accounts',
  },
  {
    group: 'management',
    label: 'sidebar.Users',
    to: '/users',
    icon: 'groups',
  },
];
